module.exports = __webpack_public_path__ + "img/live-gif.783089d3.gif";